import * as React from 'react';
const toastContainerContextDefaultValue = {
    close: ()=>null,
    intent: undefined,
    bodyId: '',
    titleId: ''
};
const ToastContainerContext = /*#__PURE__*/ React.createContext(undefined);
export const ToastContainerContextProvider = ToastContainerContext.Provider;
export const useToastContainerContext = ()=>{
    var _React_useContext;
    return (_React_useContext = React.useContext(ToastContainerContext)) !== null && _React_useContext !== void 0 ? _React_useContext : toastContainerContextDefaultValue;
};
